<template>
  <div
    ref="$container"
    :class="[
      $style.overlay,
      isOpen && $style['overlay--open'],
    ]"
    @click="event => event.target === $refs.$container && close()"
  >
    <div
      :class="[
        $style.content,
        windowsWidth <= 700 && $style.mobileOverlay
      ]"
    >
      <div
        v-once
        :class="$style.close"
        @click="close"
      >
        <deleteIcon />
      </div>
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
.overlay {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 2;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s ease-in-out;

  &--open {
    opacity: 1;
    visibility: visible;
  }
}

.container {
  text-align: center;
}

.content {
  position: relative;
  display: inline-block;
  text-align: left;
  width: 720px;
  height: 560px;
  border-radius: 8px;
  box-shadow: 0 4px 13px 0 rgba(0, 0, 0, 0.15);
  background-color: #fff;
  padding: 50px;
  box-sizing: border-box;

  &.mobileOverlay {
    width: 348px;
    padding: 27px;
    padding-bottom: 80px;
  }
}

.close {
  position: absolute;
  top: 30px;
  right: 30px;
  width: 20px;
  height: 20px;
  padding: 4px;
  cursor: pointer;

  svg {
    width: 100%;
    height: 100%;
  }
}

</style>

<script>
import { mapState } from 'vuex';
import deleteIcon from '@/images/icons/delete.svg';

export default {
  components: {
    deleteIcon,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      windowsWidth: state => state.ui.windowsWidth,
    }),
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
